"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./defineProperty-b53f90b9.js"),
  t = require("./slicedToArray-a539bf82.js"),
  a = require("react"),
  n = require("prop-types"),
  r = require("./leadForms-9c92e357.js"),
  l = require("@nmx/utils-frontend/dist/services/FrontendHttpService"),
  i = require("@nmx/utils-frontend/dist/utilities/frontend/location"),
  o = require("@nmx/utils-frontend/dist/utilities/frontend/session"),
  d = require("@nmx/utils-frontend/dist/utilities/validators"),
  c = require("@nmx/utils-frontend/dist/services/LeadService/Frontend"),
  u = require("./processAgentId-d8cdc338.js"),
  s = require("./grid-965d799c.js"),
  m = require("./form-6fff03ed.js"),
  f = require("./typography-fb2881fe.js"),
  p = require("./taggedTemplateLiteral-97b463ad.js"),
  h = require("styled-components"),
  g = require("polished/lib/helpers/rem"),
  v = require("./foundations/Illustration/illustrations/darkTheme/GetMatched.js"),
  y = require("./foundations/Icon/icons/utility/CaratRight.js"),
  E = require("./gradients-74ddcb08.js"),
  w = require("./link-8b1ebef7.js"),
  b = require("./foundations/Icon/icons/illustrative/darkTheme/MagnifyingGlass.js"),
  T = require("./foundations/Icon/icons/illustrative/darkTheme/ThumbsUp.js"),
  k = require("./progressBar-fbded569.js"),
  F = require("./textField-620b6b11.js"),
  A = require("./select-36ef8ccd.js"),
  x = require("./foundations/Icon/icons/utility/ChevronLeft.js"),
  L = require("./button-aa3e9cf5.js"),
  C = require("./sectionContainer-2a921e1c.js"),
  S = require("./inlineTooltip-4e45a12a.js"),
  _ = require("./widowBlock-bd32f3ea.js");
function M(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var N,
  R,
  V,
  I,
  P,
  B,
  W,
  j,
  q,
  z = M(a),
  U = M(n),
  O = M(l),
  D = M(i),
  G = M(o),
  H = M(c),
  Y = M(h),
  $ = M(g),
  J = [{
    name: "Choose one",
    value: "",
    disabled: !0
  }, {
    name: "Buy a home",
    value: "Buy a home",
    disabled: !1
  }, {
    name: "Save for college",
    value: "Save for college",
    disabled: !1
  }, {
    name: "Save for retirement",
    value: "Save for retirement",
    disabled: !1
  }, {
    name: "Protect my income",
    value: "Protect my income",
    disabled: !1
  }, {
    name: "Plan for my growing family",
    value: "Plan for my growing family",
    disabled: !1
  }, {
    name: "Protect my family",
    value: "Protect my family",
    disabled: !1
  }, {
    name: "Grow my business",
    value: "Grow my business",
    disabled: !1
  }, {
    name: "Grow my investments",
    value: "Grow my investments",
    disabled: !1
  }, {
    name: "I'm not sure",
    value: "I'm not sure",
    disabled: !1
  }],
  K = [{
    name: "Select a range",
    value: "",
    disabled: !0
  }, {
    name: "less than $40,000",
    value: "39999",
    disabled: !1
  }, {
    name: "$40,001 - $75,000",
    value: "57500",
    disabled: !1
  }, {
    name: "$75,001 - $100,000",
    value: "87500",
    disabled: !1
  }, {
    name: "$100,001 - $150,000",
    value: "125000",
    disabled: !1
  }, {
    name: "$150,001 - $200,000",
    value: "175000",
    disabled: !1
  }, {
    name: "$200,001 - $300,000",
    value: "250000",
    disabled: !1
  }, {
    name: "more than $300,000",
    value: "300000",
    disabled: !1
  }],
  Z = Y["default"](v)(N || (N = p._taggedTemplateLiteral([" /** TODO: this will probably be moved to Loading Component */\n  height: ", ";\n  width: ", ";\n  margin-bottom: ", ";\n"])), $["default"](65), $["default"](300), $["default"](30)),
  Q = h.keyframes(R || (R = p._taggedTemplateLiteral(["\n  0% {\n    width: 0;\n  }\n  25% {\n    width: ", ";\n  }\n  50% {\n    width: ", ";\n  }\n  75% {\n    width: ", ";\n  }\n  100% {\n    width: 0;\n  }\n"])), $["default"](10), $["default"](18), $["default"](30)),
  X = Y["default"].span(V || (V = p._taggedTemplateLiteral(["\n  ::after {\n    position: absolute;\n    display: inline-block;\n    overflow: hidden;\n    width: 0;\n    animation: ", " steps(1, end) 2s infinite;\n    content: '...';\n    vertical-align: bottom;\n  }\n"])), Q),
  ee = function ee(e) {
    var t = e.branding,
      a = e.themeType;
    return z["default"].createElement(s.Container, null, "pcg" !== t && z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(Z, null)), z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(f.TypographyComponent, {
      component: "p",
      variant: "h3",
      themeType: a
    }, "Just a moment", z["default"].createElement(X, null))));
  };
Y["default"](b)(I || (I = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
  var t = e.theme,
    a = e.formvariant,
    n = 0,
    r = $["default"](50),
    l = t.xlargeUp();
  return t.mediumUp() && (n = $["default"](-25)), "hero" === a && l && (r = $["default"](60)), h.css(P || (P = p._taggedTemplateLiteral(["\n      width: ", ";\n      margin-top: ", ";\n      margin-bottom: ", ";\n    "])), r, n, $["default"](10));
});
var te,
  ae,
  ne,
  re,
  le,
  ie,
  oe,
  de,
  ce,
  ue = Y["default"](w.LinkComponent)(B || (B = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.themeType,
      n = e.disableBottomPadding,
      r = t.mediumUp();
    return h.css(W || (W = p._taggedTemplateLiteral(["\n    display: block;\n    padding-bottom: ", ";\n    text-align: ", ";\n    ", "\n  "])), n ? 0 : $["default"](24), r ? "center" : "left", "nmx-pcg" === a && "\n      color: ".concat(t.colors.neutral.white, ";\n      text-decoration: underline;\n      :hover,\n      :active {\n        color: ").concat(t.colors.brand.pcg.gray, ";\n      }\n    "));
  }),
  se = Y["default"](f.TypographyComponent)(j || (j = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.themeType;
    return h.css(q || (q = p._taggedTemplateLiteral(["\n    text-align: center;\n    ", ";\n  "])), "nmx-pcg" === t && "\n      text-transform: uppercase;\n      letter-spacing: ".concat($["default"](4), ";\n      font-weight: 400;\n      ::after {\n        content: '';\n        display: block;\n        height: ").concat($["default"](3), ";\n        width: ").concat($["default"](100), ";\n        margin: ").concat($["default"](10), " auto 0;\n        ").concat(E.gradients.pcgGold, ";\n      }\n    "));
  }),
  me = Y["default"](s.Container)(te || (te = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.formvariant,
      n = t.mediumUp();
    return "hero" === a && h.css(ae || (ae = p._taggedTemplateLiteral(["\n        margin-top: ", ";\n        margin-bottom: ", ";\n      "])), n ? $["default"](50) : $["default"](32), n ? $["default"](60) : $["default"](48));
  }),
  fe = function fe(e) {
    var t = e.theme,
      a = e.formvariant,
      n = 0,
      r = $["default"](50),
      l = t.xlargeUp();
    return t.mediumUp() && (n = $["default"](-25)), "hero" === a && l && (r = $["default"](60)), h.css(ne || (ne = p._taggedTemplateLiteral(["\n    width: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), r, n, $["default"](10));
  },
  pe = Y["default"](T)(re || (re = p._taggedTemplateLiteral(["\n  ", ";\n"])), fe),
  he = Y["default"](b)(le || (le = p._taggedTemplateLiteral(["\n  ", ";\n"])), fe),
  ge = function ge(e, t) {
    var a = "h4";
    return "hero" !== e && "pcg" !== t || (a = "h2"), a;
  },
  ve = function ve(e) {
    var t = 300;
    return "pcg" === e && (t = 400), t;
  },
  ye = function ye(e) {
    var t = e.branding,
      a = e.themeType,
      n = e.userName,
      r = e.variant;
    return z["default"].createElement(me, {
      formvariant: r,
      id: "in-page-lead-no-match-view"
    }, z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(he, {
      formvariant: r
    })), z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(s.Col, {
      align: "center"
    }, z["default"].createElement(se, {
      formvariant: r,
      nextElement: "typography",
      themeType: a,
      variant: ge(r, t)
    }, "We couldn't find a match for you, ", n, "."))), z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(s.Col, {
      medium: 8
    }, z["default"].createElement(f.TypographyComponent, {
      nextElement: "graphic",
      themeType: a,
      weight: ve(t)
    }, "Thanks for your interest in working with us. At this time, we don't have a financial advisor that would be right for your current needs. But we can still help you reach your goals. Here are some articles that might interest you: "), z["default"].createElement(ue, {
      endAdornment: y,
      endAdornmentStylesReset: !0,
      id: "in-page-lead-form-no-match-4-steps-link",
      linkUrl: "https://www.northwesternmutual.com/life-and-money/4-steps-to-building-a-solid-financial-foundation/",
      themeType: a,
      variant: "primaryDeemphasize"
    }, "4 Steps to Building a Solid Financial Foundation"), z["default"].createElement(ue, {
      endAdornment: y,
      endAdornmentStylesReset: !0,
      id: "in-page-lead-form-no-match-good-financial-plan-link",
      linkUrl: "https://www.northwesternmutual.com/life-and-money/what-is-included-in-a-financial-plan/",
      themeType: a,
      variant: "primaryDeemphasize"
    }, "What Is Included in a Good Financial Plan?"), z["default"].createElement(ue, {
      disableBottomPadding: !0,
      endAdornment: y,
      endAdornmentStylesReset: !0,
      id: "in-page-lead-form-no-match-modern-retirement",
      linkUrl: "https://www.northwesternmutual.com/life-and-money/planning-for-a-modern-retirement/",
      themeType: a,
      variant: "primaryDeemphasize"
    }, "Planning for a Modern Retirement"))));
  };
ye.propTypes = {
  branding: U["default"].oneOf(["nm", "pcg"]),
  themeType: U["default"].oneOf(["lightTheme", "darkTheme"]),
  userName: U["default"].string,
  variant: U["default"].oneOf(["embedded", "hero"]).isRequired
}, ye.defaultProps = {
  branding: "nm",
  themeType: "darkTheme",
  variant: "embedded"
};
var Ee = Y["default"](w.LinkComponent)(ie || (ie = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.themeType;
    return h.css(oe || (oe = p._taggedTemplateLiteral(["\n    ", "\n  "])), "nmx-pcg" === a && "\n      color: ".concat(t.colors.neutral.white, ";\n      text-decoration: underline;\n      :hover,\n      :active {\n        color: ").concat(t.colors.brand.pcg.gray, ";\n      }\n    "));
  }),
  we = Y["default"](f.TypographyComponent)(de || (de = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.formvariant,
      n = e.themeType,
      r = "0 ".concat($["default"](30), " ").concat($["default"](5));
    return t.xlargeUp() && (r = 0), h.css(ce || (ce = p._taggedTemplateLiteral(["\n      ", ";\n      text-align: center;\n      /** TODO: these reusable PCG gradients should be somewhere, will find them */\n      ", ";\n    "])), "hero" === a && "padding: ".concat(r), "nmx-pcg" === n && "\n        text-transform: uppercase;\n        letter-spacing: ".concat($["default"](4), ";\n        font-weight: 400;\n        ::after {\n          content: '';\n          display: block;\n          height: ").concat($["default"](3), ";\n          width: ").concat($["default"](100), ";\n          margin: ").concat($["default"](10), " auto 0;\n          ").concat(E.gradients.pcgGold, ";\n        }\n      "));
  }),
  be = function be(e) {
    var t,
      a = e.branding,
      n = e.themeType,
      r = e.userName,
      l = e.variant,
      i = (t = !1, "hero" === l && (t = !0), t);
    return z["default"].createElement(me, {
      formvariant: l,
      id: "in-page-lead-thank-you-view"
    }, "pcg" !== a && z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(pe, {
      formvariant: l
    })), z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(s.Col, {
      align: "center"
    }, z["default"].createElement(we, {
      formvariant: l,
      variant: ge(l, a),
      themeType: n
    }, "Got it! Thanks, ", r, "."), i && z["default"].createElement(f.TypographyComponent, {
      variant: "h2",
      themeType: n,
      disableBottomPadding: !0
    }, "We're excited to work with you."))), !i && z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(s.Col, {
      medium: 10
    }, z["default"].createElement(f.TypographyComponent, {
      weight: ve(a),
      themeType: n,
      nextElement: "graphic"
    }, "We're excited to work with you. Your advisor will reach out soon to talk about your goals. Until then, check out ", z["default"].createElement(Ee, {
      id: "in-page-lead-form-guide-on-what-to-expect-link",
      linkUrl: "/email-landing/prospect/get-the-most-from-your-first-advisor-meeting?utm_source=NMCOM&utm_medium=LandingPage&utm_term=na&utm_campaign=FAFA&utm_content=Let%27s_Get_Ready",
      variant: "primaryDeemphasize",
      themeType: n
    }, "our guide on what you can expect"), " from your first meeting and what to have handy."), function (e) {
      var t = !1;
      return "pcg" === e && (t = !0), t;
    }(a) && z["default"].createElement(f.TypographyComponent, {
      component: "small",
      themeType: n,
      disableBottomPadding: !0
    }, "We do our best to match you with an advisor based on what you told us. While unlikely, there are circumstances that could prevent us from matching you to an advisor at a Private Client Group firm. If this should happen, we'll still make sure to match you with an equally qualified advisor that will fit your needs."))));
  };
be.propTypes = {
  branding: U["default"].oneOf(["nm", "pcg"]),
  themeType: U["default"].oneOf(["lightTheme", "darkTheme"]),
  userName: U["default"].string,
  variant: U["default"].oneOf(["embedded", "hero"]).isRequired
}, be.defaultProps = {
  branding: "nm",
  themeType: "darkTheme",
  variant: "embedded"
};
var Te = z["default"].forwardRef(function (e, t) {
  var a = e.hasError,
    n = e.helperText,
    r = e.onBlur,
    l = e.onChange,
    i = e.themeType,
    o = e.value;
  return z["default"].createElement(F.TextFieldComponent, {
    hasError: a,
    helperText: n,
    id: "in-page-lead-form-age-input",
    labelText: "Age",
    maxLength: 3,
    name: "age",
    onBlur: r,
    onChange: l,
    ref: t,
    required: !0,
    themeType: i,
    value: o
  });
});
Te.propTypes = {
  onChange: U["default"].func,
  value: U["default"].string
};
var ke = z["default"].forwardRef(function (e, t) {
  var a = e.hasError,
    n = e.helperText,
    r = e.onBlur,
    l = e.onChange,
    i = e.themeType,
    o = e.value;
  return z["default"].createElement(F.TextFieldComponent, {
    hasError: a,
    helperText: n,
    id: "in-page-lead-form-email-input",
    labelText: "Email",
    maxLength: 200,
    name: "email",
    onChange: l,
    onBlur: r,
    ref: t,
    required: !0,
    themeType: i,
    value: o
  });
});
ke.propTypes = {
  onChange: U["default"].func,
  value: U["default"].string
};
var Fe,
  Ae,
  xe,
  Le,
  Ce,
  Se,
  _e,
  Me,
  Ne,
  Re = z["default"].forwardRef(function (e, t) {
    var a = e.hasError,
      n = e.helperText,
      r = e.onBlur,
      l = e.onChange,
      i = e.themeType,
      o = e.value;
    return z["default"].createElement(F.TextFieldComponent, {
      hasError: a,
      helperText: n,
      id: "in-page-lead-form-first-name-input",
      labelText: "First name",
      maxLength: 20,
      name: "firstName",
      onBlur: r,
      onChange: l,
      ref: t,
      required: !0,
      themeType: i,
      value: o
    });
  });
Re.propTypes = {
  onChange: U["default"].func,
  value: U["default"].string
};
var Ve = Y["default"].label(Fe || (Fe = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = "".concat($["default"](20), " ").concat($["default"](5), " ").concat($["default"](10), ";");
    return t.mediumUp() && (a = "".concat($["default"](20), " 0 ").concat($["default"](10), ";")), h.css(Ae || (Ae = p._taggedTemplateLiteral(["\n      border: 1px solid ", ";\n      border-radius: 2px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      position: relative;\n      align-items: center;\n      width: 100%;\n      padding: ", ";\n      cursor: pointer;\n      text-align: center;\n      &:hover,\n      &:focus {\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n      &.is-active {\n        background-color: ", ";\n        .fafa-hero-goal-card-label-text {\n          color: ", ";\n        }\n        /** dynamically change SVG icon colors */\n        .dynamic-stroke {\n          stroke: ", ";\n        }\n        .dynamic-fill {\n          fill: ", ";\n        }\n      }\n    "])), t.colors.sky.sky, a, t.colors.action.darkTheme.ctaBgSecondaryHover, t.colors.action.darkTheme.ctaBgSecondaryActive, t.colors.background.lightTheme.lightA, t.colors.text.lightTheme["default"], t.colors.background.darkTheme.darkDefault, t.colors.background.darkTheme.darkDefault);
  }),
  Ie = Y["default"].input(xe || (xe = p._taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  opacity: 0;\n"]))),
  Pe = Y["default"].div(Le || (Le = p._taggedTemplateLiteral(["\n  ", ""])), function (e) {
    var t = e.theme.mediumUp();
    return h.css(Ce || (Ce = p._taggedTemplateLiteral(["\n    display: flex;\n    overflow: hidden;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    margin-bottom: ", ";\n    height: ", ";\n    svg {\n      height: 100%;\n      width: 100%;\n      pointer-events: none;\n    }\n  "])), $["default"](5), t ? $["default"](50) : $["default"](40));
  }),
  Be = Y["default"].div(Se || (Se = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = t.mediumUp(),
      n = t.largeUp(),
      r = t.xlargeUp(),
      l = $["default"](45);
    return r ? l = $["default"](30) : n ? l = $["default"](45) : a && (l = $["default"](30)), h.css(_e || (_e = p._taggedTemplateLiteral(["\n      display: flex;\n      overflow: hidden;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      padding: 0;\n      height: ", ";\n    "])), l);
  }),
  We = Y["default"](f.TypographyComponent)(Me || (Me = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = $["default"](14),
      n = $["default"](22);
    return t.mediumUp() && (a = $["default"](15), n = $["default"](25)), h.css(Ne || (Ne = p._taggedTemplateLiteral(["\n      color: ", ";\n      font-weight: 500;\n      font-size: ", ";\n      line-height: ", ";\n    "])), t.colors.text.darkTheme["default"], a, n);
  }),
  je = z["default"].forwardRef(function (e, t) {
    var a = e.icon,
      n = e.id,
      r = e.value,
      l = e.onChange;
    return z["default"].createElement(Ve, {
      className: "fafa-hero-goal-card"
    }, z["default"].createElement(Pe, null, a), z["default"].createElement(Be, null, z["default"].createElement(We, {
      id: "goal-text-".concat(n),
      className: "fafa-hero-goal-card-label-text",
      disableBottomPadding: !0
    }, r)), z["default"].createElement(Ie, {
      className: "fafa-hero-goal-card-radio-input",
      ref: t,
      id: n,
      name: "goal",
      value: r,
      onChange: l,
      required: !0,
      "data-type": "goals-card",
      type: "radio"
    }));
  });
je.propTypes = {
  value: U["default"].string,
  onChange: U["default"].func,
  icon: U["default"].object
};
var qe = z["default"].forwardRef(function (e, t) {
  var a = e.hasError,
    n = e.helperText,
    r = e.onBlur,
    l = e.onChange,
    i = e.themeType,
    o = e.value;
  return z["default"].createElement(A.SelectComponent, {
    hasError: a,
    helperText: n,
    id: "in-page-lead-form-goal-select",
    labelText: "What's your biggest financial goal?",
    name: "goal",
    onBlur: r,
    onChange: l,
    options: J,
    ref: t,
    required: !0,
    themeType: i,
    value: o
  });
});
qe.propTypes = {
  onChange: U["default"].func,
  value: U["default"].string
};
var ze = z["default"].forwardRef(function (e, t) {
  var a = e.hasError,
    n = e.helperText,
    r = e.onBlur,
    l = e.onChange,
    i = e.themeType,
    o = e.value;
  return z["default"].createElement(A.SelectComponent, {
    hasError: a,
    helperText: n,
    id: "in-page-lead-form-income-range-select",
    labelText: "Annual household income",
    name: "incomeRange",
    onBlur: r,
    onChange: l,
    options: K,
    ref: t,
    required: !0,
    themeType: i,
    value: o
  });
});
ze.propTypes = {
  onChange: U["default"].func,
  value: U["default"].string
};
var Ue = z["default"].forwardRef(function (e, t) {
  var a = e.hasError,
    n = e.helperText,
    r = e.onBlur,
    l = e.onChange,
    i = e.themeType,
    o = e.value;
  return z["default"].createElement(F.TextFieldComponent, {
    hasError: a,
    helperText: n,
    id: "in-page-lead-form-last-name-input",
    labelText: "Last name",
    maxLength: 30,
    name: "lastName",
    onBlur: r,
    onChange: l,
    ref: t,
    required: !0,
    themeType: i,
    value: o
  });
});
Ue.propTypes = {
  onChange: U["default"].func,
  value: U["default"].string
};
var Oe = z["default"].forwardRef(function (e, t) {
  var a = e.hasError,
    n = e.helperText,
    r = e.onBlur,
    l = e.onChange,
    i = e.onKeyUp,
    o = e.themeType,
    d = e.value;
  return z["default"].createElement(F.TextFieldComponent, {
    hasError: a,
    helperText: n,
    id: "in-page-lead-form-phone-input",
    labelText: "Phone number",
    maxLength: 14,
    name: "phone",
    onBlur: r,
    onChange: l,
    onKeyUp: i,
    ref: t,
    required: !0,
    themeType: o,
    type: "tel",
    value: d
  });
});
Oe.propTypes = {
  onChange: U["default"].func,
  onKeyUp: U["default"].func,
  value: U["default"].string
};
var De = z["default"].forwardRef(function (e, t) {
  var a = e.hasError,
    n = e.helperText,
    r = e.onBlur,
    l = e.onChange,
    i = e.themeType,
    o = e.value;
  return z["default"].createElement(A.SelectComponent, {
    hasError: a,
    helperText: n,
    id: "in-page-lead-form-wealth-range-select",
    labelText: "Net Worth",
    name: "wealthRange",
    onBlur: r,
    onChange: l,
    options: K,
    ref: t,
    required: !0,
    themeType: i,
    value: o
  });
});
De.propTypes = {
  value: U["default"].string,
  onChange: U["default"].func
};
var Ge = z["default"].forwardRef(function (e, t) {
  var a = e.hasError,
    n = e.helperText,
    r = e.onBlur,
    l = e.onChange,
    i = e.themeType,
    o = e.value;
  return z["default"].createElement(F.TextFieldComponent, {
    hasError: a,
    helperText: n,
    id: "in-page-lead-form-zip-input",
    labelText: "U.S. ZIP code",
    maxLength: 5,
    name: "zip",
    onBlur: r,
    onChange: l,
    ref: t,
    required: !0,
    themeType: i,
    value: o
  });
});
Ge.propTypes = {
  onChange: U["default"].func,
  value: U["default"].string
};
var He,
  Ye,
  $e,
  Je,
  Ke,
  Ze,
  Qe,
  Xe,
  et,
  tt,
  at,
  nt,
  rt,
  lt,
  it,
  ot,
  dt,
  ct,
  ut,
  st,
  mt,
  ft,
  pt,
  ht = Y["default"](s.Container)(He || (He = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = !1;
    return "hero" === e.variant && (t = !0), h.css(Ye || (Ye = p._taggedTemplateLiteral(["\n      ", ";\n    "])), t && "padding: 0");
  }),
  gt = Y["default"](s.Row)($e || ($e = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = $["default"](20);
    return t.mediumUp() && (a = 0), h.css(Je || (Je = p._taggedTemplateLiteral(["\n      margin-bottom: ", ";\n    "])), a);
  }),
  vt = Y["default"](C.SectionContainerComponent)(Ke || (Ke = p._taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n  z-index: 2;\n  && {\n    padding: 0;\n  }\n  max-width: unset;\n  overflow: hidden;\n  && {\n    > .nmx-container {\n      max-width: unset;\n      padding: 0;\n    }\n  }\n  @media print {\n    display: none !important;\n  }\n"]))),
  yt = Y["default"].div(Ze || (Ze = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t,
      a = e.theme,
      n = e.views,
      r = e.variant,
      l = e.displayWealthRange,
      i = e.errors,
      o = function (e) {
        for (var t = Object.entries(e), a = 0; a < t.length; a += 1) if (t[a][1]) return t[a][0];
        return !1;
      }(n),
      d = !0,
      c = a.mediumUp(),
      u = a.largeUp();
    if ("hero" === r) {
      var s, m, f;
      if ("isActiveViewStep1" === o) f = $["default"](960);else if ("isActiveViewStep2" === o) {
        var g = 555;
        l && (g += 100), i.age && (g += 30), i.zip && (g += 30), i.incomeRange && (g += 30), i.wealthRange && (g += 30), f = $["default"](g);
      } else if ("isActiveViewStep3" === o) {
        var v = 555;
        i.firstName && (v += 30), i.lastName && (v += 30), f = $["default"](v);
      } else if ("isActiveViewStep4" === o) {
        f = $["default"](555);
      } else "isActiveViewThankYou" === o || "isActiveViewError" === o ? (f = $["default"](300), d = !1) : "isActiveViewNoMatch" === o ? (f = $["default"](570), d = !1) : f = $["default"](555);
      if ("isActiveViewStep1" === o) m = $["default"](710);else if ("isActiveViewStep2" === o) {
        var y = 365;
        l && (y += 100), l && (i.age || i.zip || i.incomeRange) && (y += 30), i.wealthRange && (y += 30), m = $["default"](y);
      } else m = "isActiveViewStep3" === o || "isActiveViewStep4" === o ? $["default"](365) : "isActiveViewThankYou" === o || "isActiveViewError" === o ? $["default"](280) : "isActiveViewNoMatch" === o ? $["default"](520) : $["default"](365);
      s = "isActiveViewStep1" === o ? $["default"](600) : "isActiveViewThankYou" === o ? $["default"](300) : "isActiveViewNoMatch" === o ? $["default"](500) : $["default"](370), t = u ? s : c ? m : f;
    } else {
      var E = $["default"](700),
        w = $["default"](410),
        b = $["default"](295);
      "isActiveViewStep1" === o ? E = $["default"](380) : "isActiveViewNoMatch" === o && (E = $["default"](580), w = $["default"](550), b = $["default"](520)), t = u ? b : c ? w : E;
    }
    return h.css(Qe || (Qe = p._taggedTemplateLiteral(["\n      position: relative;\n      width: 100%;\n      height: ", ";\n      transition: height 0.4s;\n      ", "\n    }"])), t, !d && "transition-property: none;");
  }),
  Et = Y["default"].div(Xe || (Xe = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.isActive,
      n = e.isAccessible,
      r = e.centered,
      l = e.themeType,
      i = "hidden",
      o = -1,
      d = 0,
      c = 48;
    return n && (i = "visible", o = 0), a && (d = 1), t.mediumUp() && (c = 60), "nmx-pcg" === l && (c += 10), h.css(et || (et = p._taggedTemplateLiteral(["\n      position: absolute;\n      display: ", ";\n      visibility: ", ";\n      z-index: ", ";\n      width: 100%;\n      height: 100%;\n      transition: opacity 0.75s;\n      opacity: ", ";\n      padding-top: ", ";\n    "])), r ? "flex" : "block", i, o, d, r ? 0 : $["default"](c));
  }),
  wt = Y["default"].div(tt || (tt = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = "hero" === e.variant,
      n = 0,
      r = "100%",
      l = t.mediumUp();
    return a ? h.css(at || (at = p._taggedTemplateLiteral(["\n        position: absolute;\n        margin-top: ", ";\n        width: ", ";\n        display: flex;\n        justify-content: center;\n        bottom: ", ";\n      "])), n, r, $["default"](50)) : (l && (n = $["default"](24), r = "auto"), h.css(nt || (nt = p._taggedTemplateLiteral(["\n      margin-top: ", ";\n      width: ", ";\n    "])), n, r));
  }),
  bt = Y["default"](L.ButtonComponent)(rt || (rt = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = "embedded" === e.formvariant,
      n = t.mediumUp();
    return h.css(lt || (lt = p._taggedTemplateLiteral(["\n      display: block;\n      ", ";\n      ", ";\n    "])), !n && "max-width: unset;", a && "width: 100%;");
  }),
  Tt = Y["default"].div(it || (it = p._taggedTemplateLiteral(["\n  /* TODO: would be nice to use our Col Component here regardless of overriding padding */\n  ", "\n"])), function (e) {
    var t,
      a = e.theme,
      n = e.inputWidth,
      r = "100%",
      l = 0,
      i = a.largeUp(),
      o = a.mediumUp();
    return i ? (t = $["default"](12), r = $["default"](n)) : o ? (t = $["default"](15), l = $["default"](20), r = $["default"](n)) : (t = 0, l = $["default"](20)), h.css(ot || (ot = p._taggedTemplateLiteral(["\n      position: relative;\n      width: ", ";\n      padding-right: ", ";\n      padding-bottom: ", ";\n    "])), r, t, l);
  }),
  kt = Y["default"].div(dt || (dt = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.isActive;
    return h.css(ct || (ct = p._taggedTemplateLiteral(["\n    opacity: ", ";\n  "])), t ? "1" : "0");
  }),
  Ft = Y["default"](L.ButtonComponent)(ut || (ut = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.branding,
      a = e.theme,
      n = e.themeType,
      r = 5,
      l = "unset",
      i = a.mediumUp(),
      o = a.largeUp(),
      d = a.xlargeUp(),
      c = a.xlargeDown(),
      u = a.colors.blue.blue;
    return o ? l = $["default"](120) : i && (l = $["default"](80)), d ? r = -12 : o ? r = -17 : i && (r = 20), "pcg" !== t && "darkTheme" !== n || (u = a.colors.neutral.white), h.css(st || (st = p._taggedTemplateLiteral(["\n      && {\n        position: absolute;\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        min-width: ", ";\n        left: ", ";\n        top: ", ";\n        z-index: 1;\n        background: transparent;\n        color: ", ";\n        ", "\n        .nmx-icon {\n          transition: margin-right 0.3s;\n        }\n        &:hover {\n          .nmx-icon {\n            margin-right: ", ";\n          }\n        }\n      }\n    "])), l, $["default"](r), $["default"](0), u, c && "padding-left:0;", $["default"](13));
  });
Y["default"](f.TypographyComponent)(mt || (mt = p._taggedTemplateLiteral(["\n  padding: 0;\n  font-weight: 400;\n"])));
var At,
  xt,
  Lt,
  Ct,
  St,
  _t,
  Mt,
  Nt,
  Rt,
  Vt,
  It,
  Pt,
  Bt,
  Wt,
  jt = Y["default"].div(ft || (ft = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = "50%",
      n = 0,
      r = $["default"](5),
      l = t.mediumUp();
    return t.largeUp() ? (a = "20%", n = $["default"](2), r = $["default"](8)) : l && (a = "".concat(100 / 3, "%"), r = $["default"](10)), h.css(pt || (pt = p._taggedTemplateLiteral(["\n      display: flex;\n      width: ", ";\n      margin-bottom: ", ";\n      padding: ", ";\n    "])), a, n, r);
  }),
  qt = Y["default"].div(At || (At = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.leftPos,
      n = -2;
    return t.mediumUp() && (n = 0), h.css(xt || (xt = p._taggedTemplateLiteral(["\n      && {\n        position: absolute;\n        top: ", ";\n        left: ", ";\n      }\n    "])), $["default"](n), "".concat(a, "px"));
  }),
  zt = Y["default"].div(Lt || (Lt = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = $["default"](-5);
    return t.mediumUp() && (a = $["default"](-3)), h.css(Ct || (Ct = p._taggedTemplateLiteral(["\n      position: relative;\n      display: inline;\n      top: ", ";\n      white-space: normal;\n    "])), a);
  }),
  Ut = function Ut(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-financial-goal",
      modalId: "tooltip-modal-financial-goal",
      themeType: e.themeType,
      tooltipText: "We realize you have lots of aspirations, but for now, choose the one goal you'd like to focus on the most. This will help us match you with a financial advisor who has the right expertise to help you reach your goal."
    }));
  },
  Ot = function Ot(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-age",
      modalId: "tooltip-modal-age",
      themeType: e.themeType,
      tooltipText: "This will help us match you with an advisor who is generally at the same life stage as yourself."
    }));
  },
  Dt = function Dt(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-zip",
      modalId: "tooltip-modal-zip",
      themeType: e.themeType,
      tooltipText: "This will help us match you with an advisor who lives in your area or who understands your hometown."
    }));
  },
  Gt = function Gt(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-income-range",
      modalId: "tooltip-modal-income-range",
      themeType: e.themeType,
      tooltipText: "We're just looking for a range so we can match you with an advisor who has the right expertise for your income level."
    }));
  },
  Ht = function Ht(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-wealth-range",
      modalId: "tooltip-modal-wealth-range",
      themeType: e.themeType,
      tooltipText: "Add up the value of everything you own (home, cars, investments, savings, etc.) and subtract what you owe (any type of loan, credit card debt, etc.). That's your net worth."
    }));
  },
  Yt = function Yt(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-first-name",
      modalId: "tooltip-modal-first-name",
      themeType: e.themeType,
      tooltipText: "Just so you know, your identity is safe with us."
    }));
  },
  $t = function $t(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-last-name",
      modalId: "tooltip-modal-last-name",
      themeType: e.themeType,
      tooltipText: "Just so you know, your identity is safe with us."
    }));
  },
  Jt = function Jt(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-email",
      modalId: "tooltip-modal-email",
      themeType: e.themeType,
      tooltipText: "Don't worry, we'll never give out your contact information."
    }));
  },
  Kt = function Kt(e) {
    return z["default"].createElement(qt, {
      leftPos: e.leftPos
    }, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-phone",
      modalId: "tooltip-modal-phone",
      themeType: e.themeType,
      tooltipText: "Don't worry, we'll never give out your contact information."
    }));
  },
  Zt = function Zt(e) {
    return z["default"].createElement(zt, null, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-financial-goal-heading",
      modalId: "tooltip-modal-financial-goal-heading",
      themeType: e.themeType,
      tooltipText: "We realize you have lots of aspirations, but for now, choose the one goal you'd like to focus on the most. This will help us match you with a financial advisor who has the right expertise to help you reach your goal."
    }));
  },
  Qt = function Qt(e) {
    return z["default"].createElement(zt, null, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-demographic-info-heading",
      modalId: "tooltip-modal-demographic-info-heading",
      themeType: e.themeType,
      tooltipText: "In case you're wondering, no, we won't share anything you share with anyone else."
    }));
  },
  Xt = function Xt(e) {
    return z["default"].createElement(zt, null, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-personal-info-heading",
      modalId: "tooltip-modal-personal-info-heading",
      themeType: e.themeType,
      tooltipText: "Just so you know, your identity is safe with us."
    }));
  },
  ea = function ea(e) {
    return z["default"].createElement(zt, null, z["default"].createElement(S.InlineTooltip, {
      branding: e.branding,
      buttonId: "tooltip-button-contact-info-heading",
      modalId: "tooltip-modal-contact-info-heading",
      themeType: e.themeType,
      tooltipText: "Don't worry, we'll never give out your contact information."
    }));
  },
  ta = function ta(e) {
    var t = [!0, ""];
    return d.isEmpty(e) && (t = [!1, "Select an option."]), t;
  },
  aa = function aa(e) {
    var t = (e || "").toString(),
      a = !!t && !d.isEmpty(t) && /^[0-9]+$/.test(t),
      n = parseInt(t, 10),
      r = [!0, ""];
    return !t || t.length < 1 ? r = [!1, "Enter age"] : a ? (n < 18 || n > 125 || "0" === t.charAt(0)) && (r = [!1, "Must be between 18-120."]) : r = [!1, "Digits only"], r;
  },
  na = function na(e) {
    var t = [!0, ""];
    return d.isEmpty(e) || !d.isString(e) ? t = [!1, "Enter ZIP code."] : d.isZipCode(e) || (t = [!1, "Must be 5 digits."]), t;
  },
  ra = function ra(e) {
    var t = [!0, ""];
    return e && !d.isEmpty(e) || (t = [!1, "Select an option."]), t;
  },
  la = function la(e, t) {
    var a = [!0, ""];
    return !e && t <= 39999 && (a = [!1, "Select an option."]), a;
  },
  ia = function ia(e) {
    var t = [!0, ""];
    return d.isEmpty(e) || !d.isString(e) || e.length > 20 ? t = [!1, "Enter first name."] : d.isFirstName(e, !0) || (t = [!1, "Enter valid name."]), t;
  },
  oa = function oa(e) {
    var t = [!0, ""];
    return d.isEmpty(e) || !d.isString(e) || e.length > 150 ? t = [!1, "Enter last name."] : d.isLastName(e, !0) || (t = [!1, "Enter valid name."]), t;
  },
  da = function da(e) {
    var t = [!0, ""];
    return d.isEmpty(e) ? t = [!1, "Enter phone number."] : d.isPhoneNumber(e) || (t = [!1, "Please enter a valid phone number."]), t;
  },
  ca = function ca(e) {
    var t = [!0, ""];
    return d.isEmpty(e) ? t = [!1, "Enter email."] : d.isEmail(e) || (t = [!1, "Enter valid email address."]), t;
  },
  ua = {
    isActiveViewStep1: !1,
    isActiveViewStep2: !1,
    isActiveViewStep3: !1,
    isActiveViewStep4: !1,
    isActiveViewIsSubmitting: !1,
    isActiveViewThankYou: !1,
    isActiveViewError: !1
  },
  sa = {
    isAccessibleStep1: !1,
    isAccessibleStep2: !1,
    isAccessibleStep3: !1,
    isAccessibleStep4: !1,
    isAccessibleIsSubmitting: !1,
    isAccessibleThankYou: !1,
    isAccessibleError: !1
  },
  ma = Y["default"](f.TypographyComponent)(St || (St = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.themeType,
      n = t.mediumUp();
    return h.css(_t || (_t = p._taggedTemplateLiteral(["\n      && {\n        position: relative;\n        padding-bottom: ", ";\n        text-align: center;\n\n        && {\n          ", "\n        }\n      }\n    "])), n ? $["default"](40) : $["default"](24), "nmx-pcg" === a && "\n            text-transform: uppercase;\n            letter-spacing: ".concat($["default"](4), ";\n            font-weight: 400;\n          "));
  }),
  fa = Y["default"](f.TypographyComponent)(Mt || (Mt = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = e.isWelcomeView,
      n = $["default"](24);
    return t.mediumUp() && (n = $["default"](40)), h.css(Nt || (Nt = p._taggedTemplateLiteral(["\n      position: relative;\n      color: ", ";\n      text-align: center;\n      ", "\n    "])), t.colors.neutral.white, !a && "padding-bottom: ".concat(n));
  }),
  pa = Y["default"].div(Rt || (Rt = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = 12,
      n = 5,
      r = 0,
      l = t.mediumUp();
    return l && (a = 26), t.xlargeUp() ? (r = 25, n = 0) : l && (n = 20), h.css(Vt || (Vt = p._taggedTemplateLiteral(["\n      position: absolute;\n      right: ", ";\n      top: ", ";\n      padding-right: ", ";\n    "])), $["default"](n), $["default"](a), $["default"](r));
  }),
  ha = Y["default"](s.Row)(It || (It = p._taggedTemplateLiteral(["\n  ", "\n"])), function (e) {
    var t = e.theme,
      a = $["default"](20);
    return t.mediumUp() && (a = $["default"](20)), h.css(Pt || (Pt = p._taggedTemplateLiteral(["\n      padding-left: ", ";\n      padding-right: ", ";\n    "])), a, a);
  }),
  ga = Y["default"].span(Bt || (Bt = p._taggedTemplateLiteral(["\n  ", "\n"])), function () {
    return h.css(Wt || (Wt = p._taggedTemplateLiteral(["\n    white-space: nowrap;\n  "])));
  }),
  va = function va(e, t, a) {
    return z["default"].createElement(s.Row, null, z["default"].createElement(s.Col, null, z["default"].createElement(ma, {
      component: t,
      variant: "h2",
      "aria-hidden": e,
      themeType: a
    }, "nmx-pcg" === a ? z["default"].createElement(z["default"].Fragment, null, "Get matched with a private client ", z["default"].createElement(_.WidowBlockComponent, null, "group advisor")) : z["default"].createElement(z["default"].Fragment, null, "Get matched with a financial advisor in four ", z["default"].createElement(_.WidowBlockComponent, null, "easy steps.")))));
  },
  ya = z["default"].createElement(ha, null, z["default"].createElement(s.Col, null, z["default"].createElement(fa, {
    component: "h2",
    variant: "h3",
    isWelcomeView: !0
  }, "What's your biggest financial ", z["default"].createElement(ga, null, "goal?", z["default"].createElement(Zt, null))), z["default"].createElement(fa, {
    isWelcomeView: !0
  }, "(Choose one)"))),
  Ea = z["default"].createElement(ha, null, z["default"].createElement(s.Col, null, z["default"].createElement(fa, {
    component: "h2",
    variant: "h3"
  }, "Tell us a bit about ", z["default"].createElement(ga, null, "yourself.", z["default"].createElement(Qt, null))))),
  wa = z["default"].createElement(ha, null, z["default"].createElement(s.Col, null, z["default"].createElement(fa, {
    component: "h2",
    variant: "h3"
  }, "Who will we be talking ", z["default"].createElement(ga, null, "with? ", z["default"].createElement(Xt, null))))),
  ba = z["default"].createElement(ha, null, z["default"].createElement(s.Col, null, z["default"].createElement(fa, {
    component: "h2",
    variant: "h3"
  }, "How do we get in touch with ", z["default"].createElement(ga, null, "you?", z["default"].createElement(ea, null))))),
  Ta = function Ta(e, t) {
    return z["default"].createElement(pa, null, z["default"].createElement(ma, {
      id: "in-page-lead-form-screen-number-".concat(e),
      className: "nmx-p",
      component: "span",
      themeType: t,
      weight: 400
    }, e, "/4"));
  };
function ka(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function Fa(t) {
  for (var a = 1; a < arguments.length; a++) {
    var n = null != arguments[a] ? arguments[a] : {};
    a % 2 ? ka(Object(n), !0).forEach(function (a) {
      e._defineProperty(t, a, n[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ka(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
var Aa,
  xa = r.NAME_PUSH_EVENTS,
  La = xa.FORM_COMPLETE_FAILURE,
  Ca = xa.FORM_COMPLETE,
  Sa = xa.FORM_INTERACT,
  _a = xa.FORM_LOAD,
  Ma = r.NAME_LEAD_FORM_EXPERIENCES.EMBEDDED_FAFA,
  Na = function Na(e, t, a, n, r, l) {
    if (t) {
      switch (e) {
        case "step1":
          a("isActiveViewStep1", "isAccessibleStep1");
          break;
        case "step2":
          "hero" === r && window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
          }), a("isActiveViewStep2", "isAccessibleStep2");
          break;
        case "step3":
          a("isActiveViewStep3", "isAccessibleStep3");
          break;
        case "step4":
          a("isActiveViewStep4", "isAccessibleStep4");
          break;
        case "isSubmitting":
          a("isActiveViewIsSubmitting", "isAccessibleIsSubmitting");
          break;
        case "thankYou":
          a("isActiveViewThankYou", "isAccessibleThankYou");
          break;
        case "error":
          a("isActiveViewError", "isAccessibleError"), clearTimeout(Aa);
          break;
        case "noMatch":
          a("isActiveViewNoMatch", "isAccessibleNoMatch");
      }
      n(!1), setTimeout(function () {
        n(!0);
      }, l);
    }
  },
  Ra = function Ra() {
    return window.location.href = "/financial-advisor-match/", !1;
  },
  Va = new O["default"]({
    baseURL: "https://nmx.cxprod.apps.northwesternmutual.com/nmx-api-proxy/nmx/ms-form-proxy",
    fullResponse: !0
  }),
  Ia = function Ia(n) {
    var l = n.applicationId,
      i = n.backgroundVariant,
      o = n.branding,
      c = n.campaign,
      f = n.config,
      p = n.formLocation,
      h = n.immediateMatchFeatureFlagEnabled,
      g = n.onFormEngaged,
      v = n.sectionId,
      y = n.specialization,
      E = n.themeType,
      w = n.variant,
      b = a.useRef(),
      T = a.useRef(),
      F = a.useRef(),
      A = a.useRef(),
      L = a.useRef(),
      C = a.useRef(),
      S = a.useRef(),
      _ = a.useRef(),
      M = a.useRef(),
      N = a.useState({
        initialActiveViewsObj: ua
      }),
      R = t._slicedToArray(N, 2),
      V = R[0],
      I = R[1],
      P = a.useState({
        initialAccessibilityObj: sa
      }),
      B = t._slicedToArray(P, 2),
      W = B[0],
      j = B[1],
      q = a.useState(),
      U = t._slicedToArray(q, 2),
      O = U[0],
      Y = U[1],
      $ = a.useState(),
      K = t._slicedToArray($, 2),
      Z = K[0],
      Q = K[1],
      X = a.useState(),
      te = t._slicedToArray(X, 2),
      ae = te[0],
      ne = te[1],
      re = a.useState(),
      le = t._slicedToArray(re, 2),
      ie = le[0],
      oe = le[1],
      de = a.useState({
        application_id: "",
        goal: "",
        age: "",
        zip: "",
        incomeRange: "",
        wealthRange: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      }),
      ce = t._slicedToArray(de, 2),
      ue = ce[0],
      se = ce[1],
      me = a.useState({
        goal: !1,
        age: !1,
        zip: !1,
        incomeRange: !1,
        wealthRange: !1,
        firstName: !1,
        lastName: !1,
        email: !1,
        phone: !1
      }),
      fe = t._slicedToArray(me, 2),
      pe = fe[0],
      he = fe[1],
      ge = a.useState({
        goal: "",
        age: "",
        zip: "",
        incomeRange: "",
        wealthRange: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: ""
      }),
      ve = t._slicedToArray(ge, 2),
      Ee = ve[0],
      we = ve[1],
      Fe = a.useState({
        step1: !1,
        step2: !1,
        step3: !1,
        step4: !1
      }),
      Ae = t._slicedToArray(Fe, 2),
      xe = Ae[0],
      Le = Ae[1],
      Ce = a.useState(!1),
      Se = t._slicedToArray(Ce, 2),
      _e = Se[0],
      Me = Se[1],
      Ne = a.useState("step1"),
      Ve = t._slicedToArray(Ne, 2),
      Ie = Ve[0],
      Pe = Ve[1],
      Be = a.useState(0),
      We = t._slicedToArray(Be, 2),
      He = We[0],
      Ye = We[1],
      $e = a.useState(!1),
      Je = t._slicedToArray($e, 2),
      Ke = Je[0],
      Ze = Je[1],
      Qe = a.useState(""),
      Xe = t._slicedToArray(Qe, 2),
      et = Xe[0],
      tt = Xe[1],
      at = a.useState(""),
      nt = t._slicedToArray(at, 2),
      rt = nt[0],
      lt = nt[1],
      it = a.useState(""),
      ot = t._slicedToArray(it, 2),
      dt = ot[0],
      ct = ot[1],
      ut = a.useState(""),
      st = t._slicedToArray(ut, 2),
      mt = st[0],
      ft = st[1],
      pt = a.useState(""),
      At = t._slicedToArray(pt, 2),
      xt = At[0],
      Lt = At[1],
      Ct = a.useState(""),
      St = t._slicedToArray(Ct, 2),
      _t = St[0],
      Mt = St[1],
      Nt = a.useState(""),
      Rt = t._slicedToArray(Nt, 2),
      Vt = Rt[0],
      It = Rt[1],
      Pt = a.useState(""),
      Bt = t._slicedToArray(Pt, 2),
      Wt = Bt[0],
      qt = Bt[1],
      zt = a.useState(""),
      Zt = t._slicedToArray(zt, 2),
      Qt = Zt[0],
      Xt = Zt[1],
      ea = a.useState(!0),
      fa = t._slicedToArray(ea, 2),
      pa = fa[0],
      ha = fa[1],
      ga = 1100,
      ka = function ka(t, a) {
        I(Fa(Fa({}, ua), {}, e._defineProperty({}, t, !0))), j(Fa(Fa({}, W), {}, e._defineProperty({}, a, !0))), setTimeout(function () {
          j(Fa(Fa({}, sa), {}, e._defineProperty({}, a, !0)));
        }, ga);
      },
      xa = function xa(e) {
        var t = e.target,
          a = t.value,
          n = t.name;
        r.interact({
          experience: Ma,
          actionType: n,
          actionValues: a,
          eventName: Sa
        });
      },
      Ia = function Ia() {
        if (ie) for (var e = 0; e < ie.length; e += 1) ie[e].style.display = "block";
        if (ae) for (var t = 0; t < ae.length; t += 1) ae[t].style.display = "none";
      },
      Pa = function Pa(e) {
        Na(e, pa, ka, ha, w, ga);
      },
      Ba = function Ba(t) {
        if ("goals-card" === t.target.getAttribute("data-type")) {
          if (null != O) for (var a = 0; a < O.length; a += 1) O[a].classList.remove("is-active"), Z[a].setAttribute("aria-checked", !1);
          t.target.parentNode.classList.add("is-active"), t.target.setAttribute("aria-checked", !0), xa(t);
        }
        var n = function (e, t) {
          var a,
            n = e.target,
            r = n.name,
            l = n.value;
          switch (r) {
            case "goal":
              a = ta(l);
              break;
            case "age":
              a = aa(l);
              break;
            case "zip":
              a = na(l);
              break;
            case "incomeRange":
              a = ra(l);
              break;
            case "wealthRange":
              a = la(l, t);
              break;
            case "firstName":
              a = ia(l);
              break;
            case "lastName":
              a = oa(l);
              break;
            case "email":
              a = ca(l);
              break;
            case "phone":
              a = da(l);
              break;
            default:
              a = [!0, ""];
          }
          return a;
        }(t, ue.incomeRange);
        he(Fa(Fa({}, pe), {}, e._defineProperty({}, t.target.name, !n[0]))), we(Fa(Fa({}, Ee), {}, e._defineProperty({}, t.target.name, n[1]))), se(Fa(Fa({}, ue), {}, e._defineProperty({}, t.target.name, t.target.value))), g();
      },
      Wa = function Wa(e) {
        var t = null,
          a = null,
          n = D["default"].getQueryParam("campName") || "NM.com In-page lead Form",
          l = JSON.parse(localStorage.getItem("sampleFinancialPlanTour")),
          i = u.processAgentId(f),
          o = {};
        "sampleFinancialPlanTour" === c && (o = {
          secondaryCampaignName: "sample-plan",
          financialGoals: l[0].financialGoals,
          ageRange: l[1].ageRange,
          relationshipStatus: l[2].relationshipStatus,
          childrenStatus: l[3].childrenStatus,
          investmentExperience: l[4].investmentExperience
        }), a = function (e, t, a, n, r) {
          return {
            application_id: e.application_id,
            goal: e.goal,
            age: e.age,
            zip: e.zip,
            income_range: e.incomeRange,
            wealth_range: e.wealthRange,
            first_name: e.firstName,
            last_name: e.lastName,
            email: e.email,
            phone: e.phone,
            campaign_name: a,
            agent_number: t,
            page_url: "undefined" != typeof window ? window.location.href : "",
            recaptcha_response_token: n,
            utm_campaign: G["default"].get("utmCampaign"),
            utm_content: G["default"].get("utmContent"),
            utm_medium: G["default"].get("utmMedium"),
            utm_source: G["default"].get("utmSource"),
            utm_term: G["default"].get("utmTerm"),
            secondaryCampaignName: r.secondaryCampaignName,
            sfpt_financialGoals: r.financialGoals,
            sfpt_ageRange: r.ageRange,
            sfpt_relationshipStatus: r.relationshipStatus,
            sfpt_childrenStatus: r.childrenStatus,
            sfpt_investmentExperience: r.investmentExperience
          };
        }(ue, i, n, e, o), a.is_recaptcha_v3 = !0, y && (a.specialization = y), r.complete({
          experience: Ma,
          submissionType: "lead",
          eventName: Ca,
          submissionData: a
        }), t = h ? Va.post("/immediate-match", a) : H["default"].submitLead(a);
        var d,
          s,
          m,
          g = (d = a.income_range, s = a.wealth_range, m = !1, "39999" === d && "39999" === s && (m = !0), m);
        !function (e, t, a) {
          e && (Aa = setTimeout(function () {
            localStorage.setItem("belowLeadMinimum", a), localStorage.setItem("diamond", "submissionTimeout"), Ra();
          }, t));
        }(h, 3e4, g);
        try {
          t.then(function (e) {
            !function (e, t, a, n, r) {
              t ? e ? (localStorage.setItem("belowLeadMinimum", !0), localStorage.setItem("diamond", a.data), Ra()) : (r("noMatch"), G["default"].set("inPageLeadFormNoMatch", !0)) : e ? (localStorage.setItem("belowLeadMinimum", !1), localStorage.setItem("diamond", a.data), Ra()) : (r("thankYou"), n(), G["default"].set("inPageLeadFormNoMatch", !1));
            }(h, g, e, Ia, Pa);
          })["catch"](function (e) {
            Pa("error"), console.error("Error submitting lead on ".concat(p, "."), e);
          });
        } catch (e) {
          Pa("error"), console.error("Error submitting lead on ".concat(p, "."), e), r.completeFailure({
            experience: Ma,
            errorMsg: "Unable to submit in-page lead form with error ".concat(e),
            eventName: La
          });
        }
      };
    return a.useEffect(function () {
      se(Fa(Fa({}, ue), {}, {
        application_id: l
      })), localStorage.setItem("belowLeadMinimum", !1), G["default"].set("inPageLeadFormNoMatch", !1), Pa("step1"), Y(document.querySelectorAll(".fafa-hero-goal-card")), Q(document.querySelectorAll(".fafa-hero-goal-card-radio-input")), ne(document.querySelectorAll(".js-hide-on-submit")), oe(document.querySelectorAll(".js-show-on-submit")), "hero" !== w && tt(b.current.getBoundingClientRect().width), lt(T.current.getBoundingClientRect().width), ct(F.current.getBoundingClientRect().width), ft(A.current.getBoundingClientRect().width), Mt(C.current.getBoundingClientRect().width), It(S.current.getBoundingClientRect().width), qt(_.current.getBoundingClientRect().width), Xt(M.current.getBoundingClientRect().width), r.load({
        experience: Ma,
        eventName: _a
      });
    }, []), a.useEffect(function () {
      if (ie) for (var e = 0; e < ie.length; e += 1) ie[e].style.display = "none";
    }, [ie]), a.useEffect(function () {
      V.isActiveViewStep1 ? (Ye(2), Pe("")) : V.isActiveViewStep2 ? (Ye(25), Pe("step1")) : V.isActiveViewStep3 ? (Ye(50), Pe("step2")) : V.isActiveViewStep4 ? (Ye(75), Pe("step3")) : V.isActiveViewIsSubmitting || V.isActiveViewError ? (Ye(100), Pe("step4")) : Pe("");
    }, [V]), a.useEffect(function () {
      _e && Lt(L.current.getBoundingClientRect().width);
    }, [_e]), a.useEffect(function () {
      var e, t, a, n, r, l, i, o, d;
      V.isActiveViewStep1 ? Le(Fa(Fa({}, xe), {}, {
        step1: (d = ue.goal, ta(d)[0])
      })) : V.isActiveViewStep2 ? (Me(ue.incomeRange && ue.incomeRange <= 39999), Le(Fa(Fa({}, xe), {}, {
        step2: (r = ue.age, l = ue.zip, i = ue.incomeRange, o = ue.wealthRange, aa(r)[0] && na(l)[0] && ra(i)[0] && la(o, i)[0])
      }))) : V.isActiveViewStep3 ? Le(Fa(Fa({}, xe), {}, {
        step3: (a = ue.firstName, n = ue.lastName, ia(a)[0] && oa(n)[0])
      })) : V.isActiveViewStep4 && Le(Fa(Fa({}, xe), {}, {
        step4: (e = ue.email, t = ue.phone, ca(e)[0] && da(t)[0])
      }));
    }, [ue]), a.useEffect(function () {
      Ze(xe.step1 && xe.step2 && xe.step3 && xe.step4);
    }, [xe.step4]), z["default"].createElement(vt, {
      backgroundVariant: i,
      branding: o,
      id: v,
      moduleName: "in-page-lead-form-module",
      moduleVariation: "A",
      themeType: E
    }, z["default"].createElement(kt, {
      isActive: V.isActiveViewStep1 || V.isActiveViewStep2 || V.isActiveViewStep3 || V.isActiveViewStep4 || V.isActiveViewIsSubmitting || V.isActiveViewThankYou || V.isActiveViewError || V.isActiveViewNoMatch
    }, z["default"].createElement(k.ProgressBarComponent, {
      branding: o,
      fillPercentage: He,
      themeType: E
    })), z["default"].createElement(m.FormComponent, {
      applicationId: l,
      id: "".concat(v, "-form"),
      legend: "Find a financial advisor form",
      onSubmit: function onSubmit(e) {
        e.preventDefault(), e.stopPropagation(), Ze(xe.step1 && xe.step2 && xe.step3 && xe.step4), Ke ? (Pa("isSubmitting"), setTimeout(function () {
          try {
            window.grecaptcha.ready(function () {
              window.grecaptcha.execute(f["public"].recaptchaV3, {
                action: "submit"
              }).then(function (e) {
                document.querySelectorAll(".recaptchaResponse").forEach(function (t) {
                  t.value = e;
                }), Wa(e);
              });
            });
          } catch (e) {
            Pa("error"), console.error("Error executing recaptcha at form submit at path: ".concat(window.location.pathname, "."), e);
          }
        }, ga)) : function () {
          try {
            window.grecaptcha.ready(function () {
              window.grecaptcha.execute(f["public"].recaptchaV3, {
                action: "reset"
              }).then(function (e) {
                document.querySelectorAll(".recaptchaResponse").forEach(function (t) {
                  t.value = e;
                });
              });
            });
          } catch (e) {
            Pa("error"), console.error("Error resetting recaptcha at form submit at path: ".concat(window.location.pathname, "."), e);
          }
        }();
      }
    }, z["default"].createElement(yt, {
      views: V,
      variant: w,
      displayWealthRange: _e,
      errors: pe
    }, Ie && z["default"].createElement(Ft, {
      branding: o,
      id: "in-page-lead-form-back-button",
      startAdornment: x,
      startAdornmentStylesReset: !0,
      themeType: E,
      variant: "tertiary",
      onClick: function onClick() {
        Pa(Ie);
      }
    }, "Back"), z["default"].createElement(Et, {
      isActive: V.isActiveViewStep1,
      "aria-hidden": !V.isActiveViewStep1,
      isAccessible: W.isAccessibleStep1,
      themeType: E
    }, z["default"].createElement(ht, {
      id: "in-page-lead-financial-goal-info-view",
      variant: w
    }, Ta(1, E), "hero" === w ? ya : va(!1, "h2", E), "hero" === w && z["default"].createElement(z["default"].Fragment, null, z["default"].createElement(gt, {
      align: "center"
    }, z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-buy-a-home",
      icon: z["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "56px",
        height: "46px",
        viewBox: "0 0 56 46"
      }, z["default"].createElement("g", {
        fill: "none"
      }, z["default"].createElement("path", {
        d: "M27.878 19.155a4.13 4.13 0 110-8.26 4.13 4.13 0 010 8.26z",
        stroke: "#FFB81C",
        strokeWidth: "1.5"
      }), z["default"].createElement("path", {
        d: "M31.21 36.39a1.863 1.863 0 10-3.726 0 1.863 1.863 0 003.725 0",
        fill: "#FFB81C"
      }), z["default"].createElement("path", {
        stroke: "#FFF",
        strokeWidth: "1.5",
        className: "dynamic-stroke",
        d: "M8.322 14.44v30.74h39.124V2.507h-7.494v6.428"
      }), z["default"].createElement("path", {
        stroke: "#FFF",
        strokeWidth: "1.5",
        className: "dynamic-stroke",
        d: "M54.898 19.294L27.876.79.855 19.294M21.463 45.138V34.382c0-8.997 12.785-8.997 12.785 0v10.756"
      }))),
      value: J[1].name,
      onChange: Ba
    })), z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-save-for-college",
      icon: z["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "62px",
        height: "44px",
        viewBox: "0 0 62 44"
      }, z["default"].createElement("title", null, "Icon graduation cap reverse"), z["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M47.348 25.255l13.544-7.58L30.865.87.84 17.675l13.544 7.58"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        d: "M7.25 14.086v15.306"
      }), z["default"].createElement("path", {
        d: "M9.361 33.563a3.066 3.066 0 00.803-2.08c0-1.666-1.304-3.017-2.913-3.017-1.61 0-2.913 1.35-2.913 3.017 0 .807.306 1.54.804 2.082l-.804 8.506.251.167c.041.028 1.028.67 2.664.67 1.637 0 2.623-.642 2.664-.67l.251-.167-.807-8.508z",
        fill: "#FFB81C"
      }), z["default"].createElement("path", {
        d: "M9.361 33.563a3.066 3.066 0 00.803-2.08c0-1.666-1.304-3.017-2.913-3.017-1.61 0-2.913 1.35-2.913 3.017 0 .807.306 1.54.804 2.082h0l-.804 8.506.251.167c.041.028 1.028.67 2.664.67 1.637 0 2.623-.642 2.664-.67l.251-.167-.807-8.508z",
        stroke: "#FFB81C"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M30.866 39.467c9.103 0 16.482-2.068 16.482-4.618 0-2.551-7.379-4.62-16.482-4.62s-16.482 2.069-16.482 4.62c0 2.55 7.38 4.618 16.482 4.618z",
        stroke: "#FFF",
        strokeWidth: "1.5"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M47.348 34.848V20.006c0-2.551-7.38-4.619-16.482-4.619-9.103 0-16.483 2.068-16.483 4.619v14.842",
        stroke: "#FFF",
        strokeWidth: "1.5"
      }))),
      value: J[2].name,
      onChange: Ba
    })), z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-save-for-retirement",
      icon: z["default"].createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "60px",
        height: "63px",
        viewBox: "0 0 60 63"
      }, z["default"].createElement("title", null, "Icon of beach chair in the sun with no border on blue background"), z["default"].createElement("g", {
        strokeWidth: "1"
      }, z["default"].createElement("g", {
        strokeWidth: "1.5",
        stroke: "none",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M1.451 52.6a3.51 3.51 0 013.538-3.51h32.278l15.334-15.037c1.376-1.365 3.636-1.365 5.012 0a3.51 3.51 0 010 4.972l-16.416 16.11c-.687.683-1.572.976-2.456.976H4.989c-1.965 0-3.538-1.56-3.538-3.51zM5.258 61.336l7.922-5.225M39.123 61.576l-7.137-5.465",
        stroke: "#FFF"
      }), z["default"].createElement("path", {
        d: "M27.465 19.056c0 2.942-2.365 5.327-5.282 5.327-2.918 0-5.283-2.385-5.283-5.327s2.365-5.328 5.283-5.328c2.917 0 5.282 2.386 5.282 5.328zM22.183 1.009v7.023M22.183 30.08v7.024M34.836 6.295l-4.925 4.966M14.453 26.85L9.53 31.819M40.077 19.056h-6.964M11.251 19.056H4.288M34.836 31.818l-4.925-4.967M14.453 11.26L9.53 6.296",
        stroke: "#FFB81C"
      })))),
      value: J[3].name,
      onChange: Ba
    })), z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-protect-my-income",
      icon: z["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "45",
        height: "53",
        viewBox: "0 0 45 53"
      }, z["default"].createElement("title", null, "Shield icon"), z["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, z["default"].createElement("path", {
        className: "dynamic-fill",
        fill: "#FFF",
        d: "M1.596 9.536v7.732c.002 13.88 2.508 27.626 20.604 34.237 18.097-6.61 20.602-20.358 20.604-34.237V9.536C34.572 9.169 27.82 6.624 22.2 1.768 16.58 6.624 9.828 9.17 1.596 9.536M22.2 52.929a.68.68 0 01-.234-.04C2.856 46.022.22 31.71.216 17.267V8.87a.69.69 0 01.67-.69C9.31 7.93 16.132 5.364 21.74.336a.691.691 0 01.92 0c5.608 5.028 12.43 7.594 20.855 7.846a.69.69 0 01.67.69v8.397c-.003 14.443-2.64 28.755-21.752 35.62a.68.68 0 01-.233.041"
      }), z["default"].createElement("path", {
        fill: "#FFB81C",
        d: "M21.4 14.954v2.016a15.22 15.22 0 00-.627.122c-1.706.376-2.953 1.32-3.64 2.952-.37.882-.48 1.806-.419 2.753.116 1.795.975 3.146 2.53 4.021.67.378 1.401.649 2.114.948.886.372 1.786.714 2.67 1.09.77.326 1.067.959 1.006 1.76-.066.868-.47 1.554-1.413 1.764a5.115 5.115 0 01-1.118.12c-1.433-.004-2.39-.713-2.84-2.074-.083-.248-.143-.503-.219-.774l-3.376.87c.289 1.26.754 2.403 1.632 3.341.998 1.067 2.27 1.55 3.703 1.709v2.609h2.183v-2.585c.439-.089.865-.156 1.28-.263 1.623-.42 2.859-1.33 3.554-2.885a5.865 5.865 0 00.409-3.522c-.271-1.468-1.043-2.604-2.362-3.35-1.03-.582-2.14-.977-3.232-1.412a27.84 27.84 0 01-1.946-.882c-.363-.177-.603-.49-.726-.881-.331-1.055.306-2.214 1.38-2.48.853-.213 1.616-.028 2.259.587.41.393.687.878.918 1.39.075.165.142.332.22.512l3.023-1.25c-.062-.534-.617-1.664-1.111-2.278-.941-1.17-2.205-1.725-3.671-1.91v-2.018H21.4z"
      }))),
      value: J[4].name,
      onChange: Ba
    })), z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-plan-for-my-growing-family",
      icon: z["default"].createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "58px",
        height: "62px",
        viewBox: "0 0 58 62"
      }, z["default"].createElement("title", null, "Baby carriage icon"), z["default"].createElement("g", {
        strokeWidth: "1"
      }, z["default"].createElement("g", {
        strokeWidth: "1.5",
        stroke: "none",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round"
      }, z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M56.879 14.344c-8.257 0-8.257 3.804-8.257 7.607",
        stroke: "#FFF"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M27.508 21.951V.84c11.66 0 21.114 9.452 21.114 21.113v3.845c0 5.278-4.318 9.596-9.596 9.596H10.693c-5.278 0-9.597-4.318-9.597-9.596v-3.846l47.526.001",
        stroke: "#FFF",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        d: "M35.8 54.01L7.524 34.852"
      }), z["default"].createElement("path", {
        d: "M42.602 53.841a7.051 7.051 0 10-14.102 0 7.051 7.051 0 0014.102 0z",
        stroke: "#FFB81C"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        d: "M13.873 54.01l28.223-19.124"
      }), z["default"].createElement("path", {
        d: "M7.07 53.841a7.051 7.051 0 1114.103 0 7.051 7.051 0 01-14.102 0z",
        stroke: "#FFB81C"
      })))),
      value: J[5].name,
      onChange: Ba
    })), z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-protect-my-family",
      icon: z["default"].createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "66px",
        height: "56px",
        viewBox: "0 0 66 56"
      }, z["default"].createElement("title", null, "Icon growing family reverse"), z["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, z["default"].createElement("path", {
        d: "M32.063 14.016l.54-.54 4.991-5.123A3.793 3.793 0 0038.891 5.5v-.14a3.799 3.799 0 00-3.795-3.795h-.26a3.77 3.77 0 00-2.683 1.111l-.093.092-.092-.092a3.768 3.768 0 00-2.683-1.111h-.26a3.8 3.8 0 00-3.795 3.794v.14a3.759 3.759 0 001.252 2.815l5.58 5.702z",
        stroke: "#FFB81C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M10.2 37.415v11.88"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10.2 37.415v11.88"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M31.177 49.032v5.226"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M31.177 49.032v5.226"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M53.561 44.212v11.401"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M53.561 44.212v11.401"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M5.149 26.151V49.49"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5.149 26.151V49.49"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M14.808 10.206a4.608 4.608 0 11-9.216 0 4.608 4.608 0 019.216 0z",
        stroke: "#FFF",
        strokeWidth: "1.5"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M15.252 25.957v23.338"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15.252 25.957v23.338"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M27.403 50.194V56"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M27.403 50.194V56"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M15.252 37.643h2.81a1.42 1.42 0 001.419-1.42h0V23.316a5.453 5.453 0 00-5.453-5.454H6.374A5.453 5.453 0 00.92 23.316v12.907h0c0 .784.636 1.42 1.42 1.42h2.809",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M58.787 44.212v11.401"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M58.787 44.212v11.401"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M31.177 49.613v5.806"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M31.177 49.613v5.806"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M34.371 49.613v5.806"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M34.371 49.613v5.806"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M15.442 44.387v5.806"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M15.442 44.387v5.806"
      }), z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M10.448 44.387v5.806"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M10.448 44.387v5.806"
      }), z["default"].createElement("g", null, z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M5.339 44.387v5.806"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M5.339 44.387v5.806"
      })), z["default"].createElement("g", null, z["default"].createElement("path", {
        fill: "#0D5383",
        d: "M48.335 44.212v11.401"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round",
        d: "M48.335 44.212v11.401"
      })), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M62.11 21.623l3.02 13.7h-.001a1.42 1.42 0 01-1.082 1.691l-2.743.604",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M58.343 10.206a4.608 4.608 0 11-9.216 0 4.608 4.608 0 019.216 0z",
        stroke: "#FFF",
        strokeWidth: "1.5"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M48.689 26.152l-3.973 18.06h18.038l-3.972-18.06"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M45.36 21.623l-3.019 13.7h0a1.42 1.42 0 001.082 1.691l2.744.604M45.36 21.623a4.632 4.632 0 014.548-3.76h7.655c2.259 0 4.14 1.619 4.548 3.76M27.193 38v16.557M34.161 38v16.557M34.683 43.028h3.268v-6.97a3.486 3.486 0 00-3.486-3.487h-7.14a3.485 3.485 0 00-3.486 3.486v6.971h3.268",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M34.364 26.053a3.47 3.47 0 11-6.939 0 3.47 3.47 0 016.939 0z",
        stroke: "#FFF",
        strokeWidth: "1.5"
      }))),
      value: J[6].name,
      onChange: Ba
    })), z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-grow-my-business",
      icon: z["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "54",
        height: "56",
        viewBox: "0 0 54 56"
      }, z["default"].createElement("title", null, "Growth Chart"), z["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, z["default"].createElement("path", {
        className: "dynamic-fill",
        fill: "#FFF",
        d: "M1.858 39.575a.433.433 0 00-.432.432v13.208c0 .238.194.432.432.432H9.97a.432.432 0 00.432-.432V40.007a.433.433 0 00-.432-.432H1.858zm8.113 15.49H1.858c-1.02 0-1.85-.83-1.85-1.85V40.007c0-1.02.83-1.85 1.85-1.85H9.97c1.02 0 1.85.83 1.85 1.85v13.208c0 1.02-.83 1.85-1.85 1.85zM22.482 31.738a.44.44 0 00-.439.438v21.032a.44.44 0 00.44.44h8.1a.44.44 0 00.439-.44V32.176a.44.44 0 00-.44-.438h-8.1zm8.1 23.327h-8.1a1.859 1.859 0 01-1.856-1.857V32.176c0-1.023.833-1.856 1.856-1.856h8.1c1.024 0 1.857.833 1.857 1.856v21.032a1.859 1.859 0 01-1.856 1.857zM43.157 13.59a.426.426 0 00-.426.425v39.206c0 .235.191.426.426.426h8.127c.234 0 .425-.19.425-.426V14.015a.426.426 0 00-.425-.426h-8.127zm8.127 41.475h-8.127a1.846 1.846 0 01-1.843-1.844V14.015c0-1.016.827-1.843 1.843-1.843h8.127c1.016 0 1.843.827 1.843 1.843v39.206a1.846 1.846 0 01-1.843 1.844z"
      }), z["default"].createElement("path", {
        fill: "#FFB81C",
        d: "M33 10.413a.85.85 0 01-.85-.85V2.426h-7.288a.85.85 0 110-1.701H33c.47 0 .85.381.85.85v7.986c0 .47-.38.85-.85.85"
      }), z["default"].createElement("path", {
        fill: "#FFB81C",
        d: "M15.059 20.445a.85.85 0 01-.603-1.45L32.396.974a.85.85 0 011.206 1.201l-17.94 18.02a.848.848 0 01-.603.25"
      }))),
      value: J[7].name,
      onChange: Ba
    })), z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-grow-my-investments",
      icon: z["default"].createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "48px",
        height: "50px",
        viewBox: "0 0 48 50"
      }, z["default"].createElement("title", null, "Icon wallet reverse"), z["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M43.12 16.427V13.36a4.136 4.136 0 00-4.123-4.124H37.24M10.005 9.236h6.664",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        stroke: "#FFB81C",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M39.116 15.519L36.079 5.344 4.961 15.52M33.744 6.04L31.378 1.34 4.961 15.52"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M44.673 26.764v-7.12a4.137 4.137 0 00-4.125-4.125H4.063A3.151 3.151 0 01.92 12.377a3.151 3.151 0 013.143-3.142h5.942",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M.92 12.545v32.072a4.136 4.136 0 004.123 4.124H40.55a4.136 4.136 0 004.124-4.124v-6.813",
        stroke: "#FFF",
        strokeWidth: "1.5"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M35.628 37.718a5.457 5.457 0 01-5.451-5.459c0-3.014 2.444-5.458 4.966-5.458h12.025v10.917h-11.54z",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M37.434 32.262a1.794 1.794 0 11-3.59.001 1.794 1.794 0 013.59 0",
        fill: "#FFF"
      }))),
      value: J[8].name,
      onChange: Ba
    })), z["default"].createElement(jt, null, z["default"].createElement(je, {
      id: "fafa-interactive-flow-goal-card-im-not-sure",
      icon: z["default"].createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "50px",
        height: "59px",
        viewBox: "0 0 50 59"
      }, z["default"].createElement("title", null, "Icon person with word bubble"), z["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M42.27 37.018a7.17 7.17 0 10-14.34 0 7.17 7.17 0 0014.34 0z",
        stroke: "#FFF",
        strokeWidth: "1.5"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M21.275 58.006v-1.01a6.793 6.793 0 016.793-6.793H42.133a6.793 6.793 0 016.793 6.793v1.01",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round"
      }), z["default"].createElement("path", {
        className: "dynamic-stroke",
        d: "M22.663 23.488h4.356a4.472 4.472 0 004.472-4.473V5.287A4.473 4.473 0 0027.019.814H5.513A4.474 4.474 0 001.04 5.287v13.728c0 2.45 2.023 4.473 4.473 4.473H15.4l7.263 6.164v-6.164z",
        stroke: "#FFF",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), z["default"].createElement("path", {
        d: "M9.158 14.122a1.845 1.845 0 11-.001-3.69 1.845 1.845 0 01.001 3.69M16.266 14.122a1.845 1.845 0 11-.001-3.69 1.845 1.845 0 01.001 3.69M23.373 14.122a1.845 1.845 0 110-3.69 1.845 1.845 0 010 3.69",
        fill: "#FFB81C"
      }))),
      value: J[9].name,
      onChange: Ba
    })), z["default"].createElement(jt, null))), z["default"].createElement(s.Row, {
      align: "center"
    }, "hero" !== w && z["default"].createElement(Tt, {
      inputWidth: 390,
      className: "nmx-col"
    }, z["default"].createElement(qe, {
      hasError: pe.goal,
      helperText: Ee.goal,
      onBlur: xa,
      onChange: Ba,
      ref: b,
      themeType: E,
      value: ue.goal
    }), z["default"].createElement(Ut, {
      branding: o,
      leftPos: et,
      themeType: E
    })), z["default"].createElement(wt, {
      variant: w
    }, z["default"].createElement(bt, {
      branding: o,
      themeType: E,
      id: "in-page-lead-step-1-next-button",
      variant: "primary",
      disabled: !xe.step1,
      ariaLabel: "Proceed to step 2",
      formvariant: w,
      onClick: function onClick() {
        Pa("step2");
      }
    }, "Next"))))), z["default"].createElement(Et, {
      isActive: V.isActiveViewStep2,
      "aria-hidden": !V.isActiveViewStep2,
      isAccessible: W.isAccessibleStep2,
      themeType: E
    }, z["default"].createElement(s.Container, {
      id: "in-page-lead-demographic-info-view"
    }, Ta(2, E), "hero" === w ? Ea : va(!0, "p", E), z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(Tt, {
      inputWidth: 140
    }, z["default"].createElement(Te, {
      hasError: pe.age,
      helperText: Ee.age,
      onBlur: xa,
      onChange: Ba,
      ref: T,
      themeType: E,
      type: "number",
      value: ue.age
    }), z["default"].createElement(Ot, {
      branding: o,
      leftPos: rt,
      themeType: E
    })), z["default"].createElement(Tt, {
      inputWidth: 160
    }, z["default"].createElement(Ge, {
      hasError: pe.zip,
      helperText: Ee.zip,
      onBlur: xa,
      onChange: Ba,
      ref: F,
      themeType: E,
      value: ue.zip
    }), z["default"].createElement(Dt, {
      branding: o,
      leftPos: dt,
      themeType: E
    })), z["default"].createElement(Tt, {
      inputWidth: 235
    }, z["default"].createElement(ze, {
      hasError: pe.incomeRange,
      helperText: Ee.incomeRange,
      onBlur: xa,
      onChange: Ba,
      ref: A,
      themeType: E,
      value: ue.incomeRange
    }), z["default"].createElement(Gt, {
      branding: o,
      leftPos: mt,
      themeType: E
    })), _e && z["default"].createElement(Tt, {
      inputWidth: 225
    }, z["default"].createElement(De, {
      hasError: pe.wealthRange,
      helperText: Ee.wealthRange,
      onBlur: xa,
      onChange: Ba,
      ref: L,
      themeType: E,
      value: ue.wealthRange
    }), z["default"].createElement(Ht, {
      branding: o,
      leftPos: xt,
      themeType: E
    })), z["default"].createElement(wt, {
      variant: w
    }, z["default"].createElement(bt, {
      branding: o,
      themeType: E,
      id: "in-page-lead-step-2-next-button",
      variant: "primary",
      disabled: !xe.step2,
      ariaLabel: "Proceed to step 3",
      formvariant: w,
      onClick: function onClick() {
        Pa("step3");
      }
    }, "Next"))))), z["default"].createElement(Et, {
      isActive: V.isActiveViewStep3,
      "aria-hidden": !V.isActiveViewStep3,
      isAccessible: W.isAccessibleStep3,
      themeType: E
    }, z["default"].createElement(s.Container, {
      id: "in-page-lead-personal-info-view"
    }, Ta(3, E), "hero" === w ? wa : va(!0, "p", E), z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(Tt, {
      inputWidth: 260
    }, z["default"].createElement(Re, {
      hasError: pe.firstName,
      helperText: Ee.firstName,
      onBlur: xa,
      onChange: Ba,
      ref: C,
      themeType: E,
      value: ue.firstName
    }), "hero" !== w && z["default"].createElement(Yt, {
      branding: o,
      leftPos: _t,
      themeType: E
    })), z["default"].createElement(Tt, {
      inputWidth: 260
    }, z["default"].createElement(Ue, {
      hasError: pe.lastName,
      helperText: Ee.lastName,
      onBlur: xa,
      onChange: Ba,
      ref: S,
      themeType: E,
      value: ue.lastName
    }), "hero" !== w && z["default"].createElement($t, {
      branding: o,
      leftPos: Vt,
      themeType: E
    })), z["default"].createElement(wt, {
      variant: w
    }, z["default"].createElement(bt, {
      branding: o,
      themeType: E,
      id: "in-page-lead-step-3-next-button",
      variant: "primary",
      disabled: !xe.step3,
      ariaLabel: "Proceed to step 4",
      formvariant: w,
      onClick: function onClick() {
        Pa("step4");
      }
    }, "Next"))))), z["default"].createElement(Et, {
      isActive: V.isActiveViewStep4,
      "aria-hidden": !V.isActiveViewStep4,
      isAccessible: W.isAccessibleStep4,
      themeType: E
    }, z["default"].createElement(s.Container, {
      id: "in-page-lead-contact-info-view"
    }, Ta(4, E), "hero" === w ? ba : va(!0, "p", E), z["default"].createElement(s.Row, {
      align: "center"
    }, z["default"].createElement(Tt, {
      inputWidth: 260
    }, z["default"].createElement(ke, {
      hasError: pe.email,
      helperText: Ee.email,
      onBlur: xa,
      onChange: Ba,
      ref: _,
      themeType: E,
      value: ue.email
    }), "hero" !== w && z["default"].createElement(Jt, {
      branding: o,
      leftPos: Wt,
      themeType: E
    })), z["default"].createElement(Tt, {
      inputWidth: 260
    }, z["default"].createElement(Oe, {
      hasError: pe.phone,
      helperText: Ee.phone,
      onBlur: xa,
      onChange: Ba,
      onKeyUp: function onKeyUp(e) {
        var t = e.target.value;
        if (d.isPhoneNumber(t)) {
          var a = d.autoFormatPhone(t);
          se(Fa(Fa({}, ue), {}, {
            phone: a
          }));
        }
      },
      ref: M,
      themeType: E,
      value: ue.phone
    }), "hero" !== w && z["default"].createElement(Kt, {
      branding: o,
      leftPos: Qt,
      themeType: E
    })), z["default"].createElement(wt, {
      variant: w
    }, z["default"].createElement(bt, {
      branding: o,
      themeType: E,
      id: "in-page-lead-step-submit-button",
      variant: "primary",
      type: "submit",
      disabled: !Ke,
      formvariant: w,
      ariaLabel: "Submit form"
    }, "Submit"))))), z["default"].createElement(Et, {
      isActive: V.isActiveViewIsSubmitting,
      "aria-hidden": !V.isActiveViewIsSubmitting,
      isAccessible: W.isAccessibleIsSubmitting,
      centered: !0,
      themeType: E
    }, z["default"].createElement(ee, {
      branding: o,
      themeType: E
    })), z["default"].createElement(Et, {
      isActive: V.isActiveViewThankYou,
      "aria-hidden": !V.isActiveViewThankYou,
      isAccessible: W.isAccessibleThankYou,
      centered: !0,
      themeType: E
    }, z["default"].createElement(be, {
      branding: o,
      themeType: E,
      userName: ue.firstName,
      variant: w
    })), z["default"].createElement(Et, {
      isActive: V.isActiveViewError,
      "aria-hidden": !V.isActiveViewError,
      isAccessible: W.isAccessibleError,
      centered: !0,
      themeType: E
    }, function (e) {
      return z["default"].createElement(s.Container, null, z["default"].createElement(s.Row, {
        align: "center"
      }, z["default"].createElement(ma, {
        themeType: e,
        variant: "h3",
        weight: 300
      }, "Unable to submit form.")));
    }(E)), z["default"].createElement(Et, {
      isActive: V.isActiveViewNoMatch,
      "aria-hidden": !V.isActiveViewNoMatch,
      isAccessible: W.isAccessibleNoMatch,
      centered: !0,
      themeType: E
    }, z["default"].createElement(ye, {
      branding: o,
      themeType: E,
      userName: ue.firstName,
      variant: w
    }))), z["default"].createElement("input", {
      type: "hidden",
      name: "recaptcha_response",
      className: "recaptchaResponse"
    })));
  };
Ia.propTypes = {
  applicationId: U["default"].string,
  backgroundVariant: U["default"].oneOf(["darkDefault", "lightA", "lightB", "lightC"]),
  branding: U["default"].oneOf(["nm", "pcg"]),
  campaign: U["default"].string,
  config: U["default"].shape({
    "public": U["default"].shape({
      recaptchaInvisible: U["default"].string
    }).isRequired
  }),
  formLocation: U["default"].string.isRequired,
  immediateMatchFeatureFlagEnabled: U["default"].bool,
  onFormEngaged: U["default"].func,
  sectionId: U["default"].string.isRequired,
  themeType: U["default"].oneOf(["lightTheme", "darkTheme"]),
  specialization: U["default"].oneOf(["SPECIAL_NEEDS"]),
  variant: U["default"].oneOf(["embedded", "hero"]).isRequired
}, Ia.defaultProps = {
  applicationId: "INPAGE-LEAD",
  backgroundVariant: "darkDefault",
  branding: "nm",
  campaign: "",
  config: {
    "public": {
      recaptchaInvisible: "6LfDgz8UAAAAADhSYaeXLOogd944BheK0b2VZoRr"
    }
  },
  immediateMatchFeatureFlagEnabled: !1,
  onFormEngaged: function onFormEngaged() {},
  themeType: "darkTheme",
  variant: "embedded"
}, exports.InPageLeadFormComponent = Ia;